import type { PromocodeInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql } from '@apollo/client'

export interface PromocodeInfoQuery {
  promocodeInfo?: PromocodeInfo
}

export interface PromocodeInfoVariables {
  promocode_id: GQL_ID
  order_id: GQL_ID
}

export const GQL_QUERY_PROMOCODE_INFO = gql`
  query($order_id: ID!, $promocode_id: ID!) {
    promocodeInfo(order_id: $order_id, promocode_id: $promocode_id) {
      id
      delivery {
        promoPercent
        salePercent
        sale
      }
      total {
        promoPercent
        salePercent
        sale
      }
    }
  }
`
